.snackbar {
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  margin: 0 16px 20px;
  z-index: var(--toast);
}

.messageEnter {
  transform: translateY(140px);
}

.messageEnterActive {
  transform: translateY(0);
  transition: transform 800ms cubic-bezier(0.4, 1.47, 1, 1.01);
}

.messageExit {
  transform: translateY(0);
}

.messageExitActive {
  transform: translateY(140px);
  transition: transform 600ms cubic-bezier(0, 0, 0.88, -0.66);
}
